module.exports = __webpack_public_path__ + "static/media/crawford.6ae6834d.png";